module.exports = __webpack_public_path__ + "static/media/4. N2. Superficie sólida, 29 x 30 x 19 cm. 2021 copy.389f47c2.png";